/**
 * E-Prescription Organization Section
 *
 * Section for organization (clinic) e-prescription connection status
 * and setup. Displayed in Practice Settings page.
 */

import { useState } from 'react';
import { CheckCircle,Medication } from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Typography,
} from '@mui/material';

import { useEPrescriptionStatus } from '../store';

import { EPrescriptionOrgSetupModal } from './EPrescriptionOrgSetupModal';

export function EPrescriptionOrgSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isOrgConnected, isLoading } = useEPrescriptionStatus();

  if (isLoading) {
    return (
      <Card elevation={1} sx={{ borderRadius: 2, border: 1, borderColor: 'grey.200' }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <CircularProgress size={24} />
            <Typography>Loading e-prescription settings...</Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <>
      <Card elevation={1} sx={{ borderRadius: 2, border: 1, borderColor: 'grey.200' }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <Medication color="primary" />
            <Typography variant="h6" component="h2">
              E-Prescriptions
            </Typography>
            {isOrgConnected && (
              <Chip
                icon={<CheckCircle />}
                label="Connected"
                color="success"
                size="small"
                sx={{ ml: 'auto' }}
              />
            )}
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Connect your organization to DoseSpot to enable electronic prescribing
            capabilities for your clinicians.
          </Typography>

          {isOrgConnected ? (
            <Typography variant="body2" color="text.secondary">
              Your organization is connected to DoseSpot. Clinicians can now register
              individually to start prescribing.
            </Typography>
          ) : (
            <Button
              variant="contained"
              color="primary"
              onClick={() => setIsModalOpen(true)}
              startIcon={<Medication />}
            >
              Connect to e-Prescriptions
            </Button>
          )}
        </CardContent>
      </Card>

      <EPrescriptionOrgSetupModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
